var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "URL_De-Link",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74521",
    "data-name": "Group 74521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74515",
    "data-name": "Group 74515"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61496",
    "data-name": "Path 61496",
    d: "M10.971,9.8l-.355-.351a.25.25,0,0,1,0-.354l1.7-1.718A2.563,2.563,0,0,0,8.718,3.726l-1.7,1.719a.25.25,0,0,1-.354,0L6.311,5.1a.25.25,0,0,1,0-.353L7.9,3.129a3.681,3.681,0,0,1,5.029-.194,3.613,3.613,0,0,1,.09,5.149L11.325,9.8A.25.25,0,0,1,10.971,9.8Z",
    fill: "#606060"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_74516",
    "data-name": "Group 74516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61497",
    "data-name": "Path 61497",
    d: "M5.836,14.142a3.511,3.511,0,0,1-3-1.269,3.691,3.691,0,0,1,.3-4.921L4.608,6.465c.242-.245.4-.245.5-.148l.355.351a.25.25,0,0,1,0,.353L3.925,8.579a2.868,2.868,0,0,0-.79,2.7A2.526,2.526,0,0,0,7.352,12.4l1.707-1.729a.25.25,0,0,1,.354,0l.355.351a.25.25,0,0,1,0,.354L8.159,13.009A3.7,3.7,0,0,1,5.836,14.142Z",
    fill: "#606060"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_74517",
    "data-name": "Group 74517"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61498",
    "data-name": "Path 61498",
    d: "M1.633,4.683H3.563a.25.25,0,0,1,.25.25v.5a.25.25,0,0,1-.25.25H1.633a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,1,1.633,4.683Z",
    fill: "#606060"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_74518",
    "data-name": "Group 74518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61499",
    "data-name": "Path 61499",
    d: "M5.006,1.383h.5a.25.25,0,0,1,.25.25V3.594a.25.25,0,0,1-.25.25h-.5a.25.25,0,0,1-.25-.25V1.633A.25.25,0,0,1,5.006,1.383Z",
    fill: "#606060"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_74519",
    "data-name": "Group 74519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61500",
    "data-name": "Path 61500",
    d: "M12.437,10.317h1.93a.25.25,0,0,1,.25.25v.5a.25.25,0,0,1-.25.25h-1.93a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,1,12.437,10.317Z",
    fill: "#606060"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_74520",
    "data-name": "Group 74520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61501",
    "data-name": "Path 61501",
    d: "M10.494,12.156h.5a.25.25,0,0,1,.25.25v1.96a.25.25,0,0,1-.25.25h-.5a.25.25,0,0,1-.25-.25v-1.96A.25.25,0,0,1,10.494,12.156Z",
    fill: "#606060"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20846",
    "data-name": "Rectangle 20846",
    width: 16,
    height: 16,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeLink);
export default __webpack_public_path__ + "static/media/deLink.3de6a4f71a7fe5b89ba0c69c9510ab31.svg";
export { ForwardRef as ReactComponent };